import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";
import MathUtil from "@/util/MathUtil";

class CashService {
    createAmountForRefund(amount){
        let amountForRefund = MathUtil.displayTwoDecimals(amount).replace(',', ''); //Just remove comma
        return parseInt(amountForRefund);
    }
    refund(amount, cartItems, refundedTipsAmount, orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/payment/cashRefund';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant,
                amount: this.createAmountForRefund(amount),
                cartItems: cartItems,
                refundedTipsAmount : refundedTipsAmount,
                orderDocumentId: orderDocumentId
            },
            {headers: basicAuth });
    }
}

export default new CashService();
